<script lang="ts">
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import type { Image } from '../types';

  export let data: Image;
</script>

<figure class="h-auto w-full">
  <DirectusImage
    imageData="{data.file}"
    pictureSizes="{{
      default: '100vw',
    }}"
    presetKeys="{Preset.Thumbnail}"
    alt="{data.file.title || data.caption}"
    imgClasses="w-full h-full object-cover mb-3"
    loading="lazy"
  />

  {#if data.caption}
    <figcaption class="text-default-500 dark:text-dark-800 mb-4 text-center text-xs">
      <!-- eslint-disable-next-line -->
      {@html data.caption}
    </figcaption>
  {/if}
</figure>
